import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { BhSearchBarComponent } from './search-bar.component';

@NgModule({
    declarations: [
        BhSearchBarComponent
    ],
    imports     : [
        CommonModule,
        RouterModule,

        MatButtonModule,
        MatIconModule
    ],
    exports     : [
        BhSearchBarComponent
    ]
})
export class BhSearchBarModule
{
}
